var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vSelect',{attrs:{"disabled":_vm.disabled,"options":_vm.options},on:{"search":_vm.onSearch},scopedSlots:_vm._u([{key:"no-options",fn:function(ref){
var search = ref.search;
var searching = ref.searching;
var loading = ref.loading;
return [(!search)?[_vm._v("\n            Ricerca digitando le prime lettere.\n        ")]:[_vm._v("\n            Nessun risultato trovato, prova con una nuova ricerca.\n        ")]]}}]),model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }